import { Component, ViewEncapsulation } from '@angular/core';
import { UserService } from '~services/user.service';
import { AuthService } from '~services/auth.service';
import { config } from '../../config';
import { animate, style, transition, trigger } from '@angular/animations';
import { StoreService } from '~services/store.service';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { environment } from '~environments/environment';
import { Subscription } from 'rxjs';
import { ConfigValuesService } from '~services/config-values.service';

@Component({
  selector: 'sa-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(-100%)' }))]),
    ]),
  ],
})
export class NavComponent {
  featureFlagKey = environment.featureFlagKey;
  expanded = false;
  userLabel: { name: string; email: string; account: string };
  config = config;
  showWell: boolean;
  isLMO: boolean;
  isDispatcher: boolean;
  isCrewLeader: boolean;
  isSandVendor: boolean;
  isAdmin: boolean;

  private subscription: Subscription;

  constructor(
    private authService: AuthService,
    private storeService: StoreService,
    public featureFlagService: FeatureFlagService,
    public userService: UserService,
    private configService: ConfigValuesService,
  ) {
    this.setUserInfo();

    this.subscription = this.userService.userContract$.subscribe(() => {
      this.setUserInfo();
    });
  }

  private setUserInfo() {
    this.userLabel = this.userService.getLabel();
    this.showWell = this.userService.canShowWells();
    this.isLMO = this.userService.isLMOAccount();
    this.isDispatcher = this.userService.isDispatcherAccount();
    this.isCrewLeader = this.userService.isCrewLeader();
    this.isSandVendor = this.userService.isSandmanAccount();
    this.isAdmin = this.userService.isAdmin();
  }

  logout() {
    this.storeService.clear();
    this.authService.logout();
  }
}
